export class AuthorizationFlow {
  static extractAuthorizationFlowError(data?: Record<string, any>): {
    authorizeFlowError?: string;
    authorizeFlowRedirect?: boolean;
  } {
    const { payments_metadata: paymentsMetadata } = data || {};
    const { authorization_params: authorizationParams } = paymentsMetadata || {};
    const { error: authorizeFlowError } = authorizationParams || {};
    const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));
    const { authorize_flow_redirect: authorizeFlowRedirect } = queryParams || {};
    return {
      authorizeFlowError,
      authorizeFlowRedirect: Boolean(authorizeFlowRedirect)
    };
  }
}
